





























import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { AxiosResponse, AxiosError } from 'axios'
import Cookies from "js-cookie";

@Component({
  components: {}
})
export default class Obfuscation extends Vue {
  private loading = true;
  private token = Cookies.get("sqfsafe_auth");

  private obfuscation = {
    id: null,
    file: null,
    ignored_files: [],
    files_not_encrypted: [],
    block_editor: true,
    encryption_key: "1,2,3,4",
    config_obfuscation: false,
    is_mod: false
  };

  private profiles = [];
  private obfuFiles = [];

  private async created() {
    let response = await axios.post('https://sqfsafe.com/api/obfuscation/list-profiles');
    let data = response.data;

    if (data.success) {
      this.profiles = data.profiles;
      
      if (this.profiles.length > 0) {
        this.obfuscation = this.profiles[0];
      }
    } else {
      alert("Error loading existing profiles, try refreshing the page");
    }

    this.loading = false;
  }

  private readfile(event) {
    let files = event.target.files;
    if (files.length == 0)
      return;

    this.obfuFiles = event.target.files;
  }

  private obfuscate() {
    if (this.obfuFiles.length == 0) {
      alert("You must choose a file to obfuscate");
      return;
    }

    if (!this.token) {
      this.$router.push('/login');
      return;
    }

    this.loading = true;

    let formData = new FormData();
    formData.append("file", this.obfuFiles[0]);
    formData.append("token", this.token);
    formData.append("settings", JSON.stringify({
      FilesNotEncrypted: this.obfuscation.files_not_encrypted,
      IgnoredFiles: this.obfuscation.ignored_files,
      BlockEdit: this.obfuscation.block_editor,
      EncryptionKey: this.obfuscation.encryption_key,
      ConfigObfuscation: this.obfuscation.config_obfuscation,
      IsMod: this.obfuscation.is_mod
    }));

    axios.post("https://sqfsafe-api.arma.dev/obfuscation", formData, {
        headers: {
         "Content-Type": "multipart/form-data"
        },
        responseType: 'blob'
    }).then((response) => {

      let fileURL = window.URL.createObjectURL(new Blob([response.data]));
      let fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute("download", this.obfuFiles[0].name);

      document.body.appendChild(fileLink);

      fileLink.click();

      this.loading = false;
    }).catch((error) => {
      console.log("axios error");
      console.log(error);


      if (error.response && error.response.status == 403) {
        alert("Looks like you're no longer authenticated, has your session timed out? Try refreshing the page and checking your subscription status.");
        return;
      } else {
        alert("Unknown server error occured. Check dev console and send Fini a screenshot.");
      }

      this.loading = false;
    })
  }
}
